<ng-container *ngIf="!!get">
    <tt-date ttLabel="order_date" [(ttModel)]="get.order_date"></tt-date>
    <tt-select ttLabel="purchasecreate_purchasestatus_id" [(ttModel)]="get.purchasestatus_id" [ttData]="purchaseStatuses" ttDataId="purchasestatus_id" ttDataName="purchasestatus_name"></tt-select>
    <tt-input *ngIf="get.show_project === '1'" ttLabel="project_name" [(ttModel)]="get.project_name" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-search" (ttClick)="openSelectProject()"></tt-form-field-button>
        </ng-container>
    </tt-input>
    <tt-search
        ttLabel="searchtext_supplier"
        [(ttModel)]="get.searchtext_supplier"
        [ttSearch]="searchSuppliers"
        (ttOnSelected)="onSupplierSelected($event)"
        (ttOnClear)="onSupplierSelected()"
    ></tt-search>
    <tt-input [hidden]="get.supplier_no == 0" ttLabel="supplier_no" [(ttModel)]="get.supplier_no" ttReadonly></tt-input>
    <tt-input ttLabel="label" [(ttModel)]="get.label"></tt-input>
    <tt-select ttLabel="businessco" [(ttModel)]="get.businessco_no" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
    <tt-select ttLabel="stockplace" [(ttModel)]="get.stockplace_id" [ttData]="stockplaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
    <tt-select
        *ngIf="get.show_department_id === '1'"
        [ttRequired]="get.setting_department_is_required === '1'"
        ttLabel="department"
        [(ttModel)]="get.department_id"
        [ttData]="departments"
        ttDataId="department_id"
        ttDataName="department_name"
    ></tt-select>

    <tt-button-save ttText="purchheadcreate_createnew" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    <tt-button-settings *ngIf="get.show_setting === '1'" ttWebpageName="purchheadcreate"></tt-button-settings>
</ng-container>
